export default [

    {
        header: 'Utilisateur',
        module: 'user',
        profile: ['Admin','AdminSuper','Technician'],
    },
    {
        title: 'Liste des Utilisateurs',
        route: 'Liste',
        icon: 'UsersIcon',
        module: 'user',
        profile: ['Admin','AdminSuper','Technician'],

    },
    {
        title: 'Ajout des Utilisateurs',
        route: 'ajouter-user',
        icon: 'UserPlusIcon',
        module: 'user',
        profile: ['Admin','AdminSuper','Technician'],

    },
    // {
    //   title: 'Utilisateur',
    //   icon: 'UsersIcon',
    //   // tag: '3',
    //   tagVariant: 'light-danger',
    //   children: [


    //   ],
    // },


]